export default "__VITE_ASSET__DyLGz5q5__"